import { FC, CSSProperties } from 'react';
import { ICON_DEFINITIONS } from './iconDefinitions';

interface IconProps {
  name: keyof typeof ICON_DEFINITIONS;
  size?: number;
  color?: string;
  title?: string;
  style?: CSSProperties;
  className?: string;
}

/**
 * Universal Icon Component
 * Renders SVG icons from SVG files
 *
 * @example
 * <Icon name="InvoiceDollar" size={24} color="#000" title="Invoice" />
 */
const Icon: FC<IconProps> = ({
  name,
  size = 16,
  color,
  title,
  style,
  className,
}) => {
  const iconDef = ICON_DEFINITIONS[name];

  if (!iconDef) {
    console.warn(`Icon "${name}" not found in icon definitions`);
    return null;
  }

  return (
    <img
      src={iconDef.src}
      alt={title || iconDef.name}
      title={title}
      width={size}
      height={size}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        filter: color ? `brightness(0) saturate(100%)` : undefined,
        ...style,
      }}
    />
  );
};

export default Icon;
